import { Player } from "../Player/Player";
import { SmallEnemy } from "../Enemies/SmallEnemy";
import { BigEnemy } from "../Enemies/BigEnemy";
import { Explode } from "../Explosions/Explosions";
import { Entrance } from "../Entrance/Entrance";
import {
  decreaseLives,
  checkCollision,
  checkEntranceCollision,
  checkEnemyPastBottom,
  updateCountdown,
  gameTimeout,
  updateScore
} from "../../redux/actions/actions";
import { ParallaxBackground } from "../ParallaxBackground/ParallaxBackground";
class Game {
  constructor(ctx, width, height, dispatch) {
    this.ctx = ctx;

    this.width = width;
    this.height = height;

    this.dispatch = dispatch;
    this.isPaused = false;
    this.delta = null;

    this.keys = {};
    
    this.explosions = [];

    this.enemies = [];
    this.enemyInterval = 1500;
    this.enemyTimer = 0;
    this.enemyTypes = ["red", "black"];

    this.score = 0;

    this.remainingLives = 5;

    this.updateScore = (score) => (this.score = score);

    this.background = new ParallaxBackground(ctx, width, height, [
      "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/Parallax100.webp",
      "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/Parallax80.webp",
      "https://dawn-unit-97b0.sdrowvieli1.workers.dev/infiltration/images/Parallax60.webp",
    ]);

    this.countdown = 90;
    this.countdownInterval = null;

    this.entrance = null;

    this.player = new Player(this, this.keys, dispatch);
  }

  startCountdown() {
    this.countdownInterval = setInterval(() => {
      if (this.isPaused) return;
      if (!this?.gameOver) this.countdown--;

      if (this.countdown === 30 && !this.entrance) {
        this.entrance = new Entrance(this);
        this.player.setEntrance(this.entrance);
      }

      if (this.countdown === 0) {
        this.dispatch(gameTimeout());
        clearInterval(this.countdownInterval);
      }

      this.dispatch(updateCountdown(this.countdown));
    }, 1000);
  }

  update(deltaTime) {
    if (this.isPaused || this.countdown === 0) return;
    let bulletCollided = false;

    if (this.entrance) {
      this.entrance.update(deltaTime);
      this.dispatch(checkEntranceCollision(this.player, this.entrance, this));
      this.player.velocity = 0.15;
      this.enemyInterval = 800;
    }

    this.enemies = this.enemies.filter((object) => !object.markedForDeletion);

    if (this.enemyTimer > this.enemyInterval) {
      this.addNewEnemy();
      this.enemyTimer = 0;
    } else {
      this.enemyTimer += deltaTime;
    }

    this.enemies.forEach((object) => object.update(deltaTime));

    this.player.update(deltaTime);

    this.enemies.forEach((enemy) => {
      this.dispatch(checkCollision(this.player, enemy, this));
      this.dispatch(checkEnemyPastBottom(enemy, this.height, this));

      if (this.isColliding(this.player, enemy)) {
        this.explosions.push(
          new Explode(this.ctx, this.player.x, this.player.y)
        );
        this.explosions.push(new Explode(this.ctx, enemy.x, enemy.y));
      }

      this.player.bullets.forEach((bullet) => {
        if (this.isColliding(bullet, enemy) && bullet.velocityY === -0.4) {
          enemy.markedForDeletion = true;
          bullet.markedForDeletion = true;
          this.score += 1;
          this.dispatch(updateScore(this.score));
          this.explosions.push(new Explode(this.ctx, enemy.x, enemy.y));
          this.player.bullets = this.player.bullets.filter(
            (bullet) => !bullet.markedForDeletion
          );
        }
      });

      this.player.bullets.forEach((bullet) => {
        if (this.isColliding(bullet, this.player) && bullet.velocityY === 0.4) {
          bulletCollided = true;
          bullet.markedForDeletion = true;

          this.explosions.push(
            new Explode(this.ctx, this.player.x, this.player.y)
          );
        }
      });
    });

    if (bulletCollided) {
      this.remainingLives -= 1;
      this.dispatch(decreaseLives(this.remainingLives));
    }

    this.explosions.forEach((explosion) => explosion.update());
    this.explosions = this.explosions.filter(
      (explosion) => explosion.frame < explosion.spriteWidth / 2
    );
    this.updateScore(this.score);
    this.background.update(deltaTime);
  }

  draw() {
    if (this.ctx) this.ctx.fillStyle = "#000";
    if (this.ctx) this.ctx.fillRect(0, 0, this.width, this.height);

    this.background.draw();
    this.enemies.forEach((object) => object.draw(this.ctx));
    this.player.draw(this.ctx);
    this.explosions.forEach((explosion) => explosion.draw());
    this.player.bullets.forEach((bullet) => bullet.draw(this.ctx));

    if (this.entrance) this.entrance.draw(this.ctx);

    this.ctx.fillStyle = "#FFF";
    this.ctx.font = "30px Arial";
    this.ctx.fillText("Timer: " + this.countdown, 10, 30);
  }

  addNewEnemy() {
    const randomEnemy =
      this.enemyTypes[Math.floor(Math.random() * this.enemyTypes.length)];
    if (randomEnemy === "red") this.enemies.push(new SmallEnemy(this));
    else if (randomEnemy === "black") this.enemies.push(new BigEnemy(this));
    this.enemies.sort((a, b) => b.y - a.y);
  }

  isColliding(object1, object2) {
    return (
      object1.x < object2.x + object2.width &&
      object1.x + object1.width > object2.x &&
      object1.y < object2.y + object2.height &&
      object1.y + object1.height > object2.y
    );
  }

  handleKeyDown = (e) => {
    e.preventDefault();
    this.keys[e.code] = true;
  };

  handleKeyUp = (e) => {
    this.keys[e.code] = false;
  };

  setupEventListeners() {
    window.addEventListener("keydown", this.handleKeyDown);
    window.addEventListener("keyup", this.handleKeyUp);
  }

  removeEventListeners() {
    window.removeEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("keyup", this.handleKeyUp);
  }
}

export { Game };
